const C = {
  name: "PayLater",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 15H18V13H16V17H20V15Z" fill="currentColor"/>
<path d="M3 1C1.34772 1 0 2.34772 0 4V11C0 12.6523 1.34772 14 3 14H10.2899C10.1013 14.6337 10 15.305 10 16C10 19.866 13.134 23 17 23C20.866 23 24 19.866 24 16C24 12.134 20.866 9 17 9V4C17 2.34772 15.6523 1 14 1H3ZM15 9.28988C13.4647 9.74682 12.1501 10.7163 11.2547 12H3C2.45228 12 2 11.5477 2 11V7H15V9.28988ZM12 16C12 13.2386 14.2386 11 17 11C19.7614 11 22 13.2386 22 16C22 18.7614 19.7614 21 17 21C14.2386 21 12 18.7614 12 16ZM15 5H2V4C2 3.45228 2.45228 3 3 3H14C14.5477 3 15 3.45228 15 4V5Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as PayLater
};
